import { classNames, type RGB as RGBType } from '@tma.js/sdk-react';
import type { FC } from 'react';

import './RGB.css';
import React from 'react';

export type RGBProps = React.JSX.IntrinsicElements['div'] & {
  color: RGBType;
};

export const RGB: FC<RGBProps> = ({ color, className, ...rest }) => (
  <span {...rest} className={classNames('rgb', className)}>
    <i className='rgb__icon' style={{ backgroundColor: color }}/>
    {color}
  </span>
);
